import MessageList from './styled';

export default MessageList;
